import React from 'react';
interface EmotionalCloseProps {
  onAddToCart: () => void;
}
export function EmotionalClose({
  onAddToCart
}: EmotionalCloseProps) {
  return <section className="py-24 md:py-32 px-4 bg-dark-primary relative overflow-hidden" data-id="element-268">
      {/* Deep gold radial glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] md:w-[60%] h-[80%] bg-gold/10 blur-[100px] rounded-full pointer-events-none" data-id="element-269"></div>

      <div className="max-w-content mx-auto relative z-10 text-center" data-id="element-270">
        <h2 className="font-serif text-4xl md:text-5xl text-cream leading-tight mb-8 max-w-3xl mx-auto text-balance" data-id="element-271">
          El mejor momento para entender esto fue hace años. El segundo mejor
          momento es ahora.
        </h2>

        <p className="font-serif italic text-gold text-xl md:text-2xl leading-relaxed mb-16 max-w-2xl mx-auto" data-id="element-272">
          "Y cuando lo entiendas, no querrás guardártelo. Querrás que las
          personas que más te importan también lo sepan."
        </p>

        <div className="mb-10" data-id="element-273">
          <div className="font-serif font-black text-5xl md:text-6xl text-gold mb-3 tracking-tight" data-id="element-274">
            <span className="text-gray-warm line-through text-3xl mr-4" data-id="element-275">
              $27
            </span>
            $17.95
          </div>
          <p className="font-sans text-cream text-[15px] mb-2" data-id="element-276">
            Ebook completo + 3 Bonus Exclusivos
          </p>
          <p className="font-sans text-green font-medium text-[14px]" data-id="element-277">
            Ahorro inmediato de $43.90
          </p>
        </div>

        <div className="max-w-md mx-auto" data-id="element-278">
          <a href="https://www.godeskcore.com/cart/42794527916080:1" target="_blank" rel="noopener noreferrer" onClick={onAddToCart} className="block w-full bg-gold hover:bg-[#D4B355] text-dark-primary font-sans font-bold text-xl py-6 px-8 rounded-md transition-all shadow-[0_0_20px_rgba(201,168,76,0.2)] hover:shadow-[0_0_30px_rgba(201,168,76,0.4)] hover:-translate-y-0.5 mb-6" data-id="element-279">
            DESCARGAR MI COPIA AHORA — $17.95
          </a>

          <p className="font-sans text-[13px] text-gray-warm mb-8" data-id="element-280">
            PDF digital · Descarga inmediata ·{' '}
            <br className="hidden md:block" data-id="element-281" />
            Acceso de por vida · No se requiere envío
          </p>

          <p className="font-sans italic text-[11px] text-gray-warm/60" data-id="element-282">
            Contenido educativo. No constituye consejo médico.
          </p>
        </div>
      </div>
    </section>;
}